import { Outlet, createFileRoute } from '@tanstack/react-router';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { stacktraceNS, useTranslation } from '@/lib/i18n';
import { TestSetsLogo } from './-components/TestSetsLogo';
export const Route = createFileRoute('/_stacktrace/test-sets/_layout')({
  component: Layout
});

/**
 * テストセット 一覧（QA Force グローバルメニュー）のレイアウト。
 *
 * タブ構成: 概要 / テストセット / 設定。
 * 現状はテストセット一覧のみ enabled。概要・設定は将来追加予定のため
 * disabled の予約タブとして表示する（test-suites / issues と同様の体裁）。
 */
function Layout() {
  const {
    t
  } = useTranslation();
  const {
    t: tStacktrace
  } = useTranslation(stacktraceNS);
  useDocumentTitle(tStacktrace('testSets.list.pageTitle'));
  const tabs = [{
    to: '/test-sets/overview' as never,
    children: t('common.list.overview'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-sets',
    children: tStacktrace('testSets.list.tabLabel'),
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-sets/alerts' as never,
    children: t('common.list.alerts'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-sets/operation-activity' as never,
    children: t('common.list.operationActivity'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-sets/rules-and-policy' as never,
    children: t('common.list.configuration'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }, {
    to: '/test-sets/settings' as never,
    children: t('common.list.settings'),
    disabled: true,
    activeOptions: {
      exact: true
    }
  }] satisfies TabWithIndicatorProps[];
  return <div className="flex flex-col h-full">
      <ProductHeader Logo={TestSetsLogo} name={tStacktrace('testSets.list.pageTitle')} tabs={tabs} type="resource" />
      <Outlet />
    </div>;
}